@if (legacyWebUI && url3_5) {
  @if (unsupportedPattern && !isProduction) {
    <p style="font-weight: bold; color:red; height: 20px;text-align: center; position:absolute; width:100%">
      CURRENTLY UNSUPPORTED SOHO XI PATTERN DETECTED
    </p>
  }
  <lm-html-url-doc
    [url]="url3_5"
    [showLoading]="false"
    (titleChanged)="onTitleChanged($event)"
  ></lm-html-url-doc>
}
@if (!url3_5) {
  @if (pageSpec && pageSpec.pageSpec.hasCartForm && emptyMessage === null) {
    <div class="leftSideCartView">
      <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
      <ng-container *ngTemplateOutlet="CompositeFormMarkup"></ng-container>
    </div>
    <!-- This is where we will handle the mobile code -->
    <div class="rightSideCartView">
      <ng-container *ngTemplateOutlet="CartFormTemplate"></ng-container>
    </div>

  }

  @if (pageSpec && !pageSpec.pageSpec.hasCartForm && emptyMessage === null) {
    @if (hasFullPageBackground) {
      <section
        class="use-background-image background-image-attributes full-page-background"
        [style.background-image]="fullPageBackgroundImage"
      >
        @if (bannerInRoute && isRouterOutletRootComponent) {   <!--   *ngIf="isRouterOutletRootComponent && (hideTitleBar || bannerInRoute)   -->
          <soho-header #SohoHeader [hasToolbar]="hasToolbar">
            <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
          </soho-header>
        } @else {
          <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
        }
        <ng-container *ngTemplateOutlet="CompositeFormMarkup"></ng-container>
      </section>
    } @else {
      @if (bannerInRoute && isRouterOutletRootComponent) {   <!--   *ngIf="isRouterOutletRootComponent && (hideTitleBar || bannerInRoute)   -->
        <soho-header #SohoHeader [hasToolbar]="hasToolbar">
          <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
        </soho-header>
      } @else {
        <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
      }
      <ng-container *ngTemplateOutlet="CompositeFormMarkup"></ng-container>
    }
  }

  @if (emptyMessage) {
    <ng-container>
      <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
    </ng-container>
  }
}
  <!-- <ng-container *ngIf="hideTitleBar">
    <lm-toolbar
        class="hideTitleToolbar"
        [inHeader]="false"
        [toolbarIdPrefix]="screenId"
        [automationId]="pageAutomationId"
        [sectionTitle]="pageTitle"
        [buttons]="toolbarButtons | async"

        (toolbarButtonEvent)="onToolbarButtonButtonEvent($event)"
    ></lm-toolbar>
  </ng-container> -->
<ng-template #CartFormTemplate>
  <lm-form #cartForm
      class ="personalize-header"
      [formUrlInfo]="cartFormUrlInfo"
      [isCartView]=true
      [formSpec]="pageSpec.pageSpec.cartForm"
      [initDataView]="contextFormDataView"
      [pageContextForm]="true"
      [formOptions]="'{}'"
      (sendContextMessageEvent)="onSendContextMessageEvent($event)"
  ></lm-form>    <!-- style="border-left: 1px solid grey; width: 25%"  -->
</ng-template>

<ng-template #CompositeFormMarkup>
  <div [ngClass]="{'hideTitleBarPageScroll': hideTitleBar}">
    @if (hasContextForm) {
      <section
        class="page-context-form"
        [class.is-personalizable]="!useThemeColor ? false : true"
        [class.use-background-image]="useBackgroundImage"
        [class.background-image-attributes]="useBackgroundImage"
        [class.foreground-light]="foregroundLight"
        [class.foreground-dark]="foregroundDark"
        [style.background-image]="backgroundImageUrl"
      >
        <lm-form
          [class.personalize-header]="useHeaderColorOnTabs"
          [class]="contextFormColorClass"
          [class.light-context-form]="lightContextForm"
          [formUrlInfo]="contextFormUrlInfo"
          [formSpec]="contextFormSpec"
          [initDataView]="contextFormDataView"
          [pageContextForm]="true"
          [formOptions]="'{}'"
        ></lm-form>
      </section>
    }
    @if (isMultiPanel && lmTabsOptions) {
      <div soho-tabs #sohoTabContainer
        disableAutoUpdatedCall="true"
        [ngClass]="{'sticky-tabs lm-horizontal tab-container': true, 'lm-banner-in-route': bannerInRoute}"
        [class.has-breadcrumbs]="hasBreadcrumbs"
        [class]="contextFormColorClass"
        [class.light-context-form]="lightContextForm"
        [class.is-personalizable]="useHeaderColorOnTabs"
        [alternate]="useAlternateTabs"
        [attributes]="pagePanelTabAttributes"
        [headerTabs]="useHeaderColorOnTabs"
        [verticalResponsive]="false"
        [class.hide-title-bar]="hideTitleBar"
        (activated)="onTabActivated($event)"
      >
        <div soho-tab-list-container>
          <ul soho-tab-list>
            @for (tab of lmTabsOptions?.tabs; track tab) {
              <li soho-tab
                  attr.id="{{testVersion1 ? 'pagepanel_' + tab.id : null}}"
                  [selected]="!!tab.selected"
              >
                <a soho-tab-title
                    attr.id="{{!testVersion1 ? tab.id + '_tab' : null}}"
                    attr.data-automation-id="lm-{{tab.automationId + '-tab'}}"
                    tabId="{{tab.id}}"
                >{{tab.title}}</a>
              </li>
            }
          </ul>
        </div>
      </div>
    }
      @if (isMultiPanel && lmTabsOptions) {
        <div soho-tab-panel-container attr.id="{{tabPanelContainerId}}" [ngStyle]="{'height': onMobile ? '100%' : hideTitleBar ? 'auto' : null}">
          <ng-container *ngTemplateOutlet="MultiPanelMarkup"></ng-container>
        </div>
      }

    <!--
    COMMON PANEL WORK
    -->
    @if (isSinglePanel && lmTabsOptions && lmTabsOptions.tabs?.length > 0) {
      <lm-page-panel
        tabindex="0"
        id="{{lmTabsOptions.tabs[0].id}}"
        #LMPagePanelComponent
        [class.lm-page-single-panel]="true"
        [panel]="lmTabsOptions.tabs[0].panel"
        [isSinglePanePage]="true"
        [overrideListTitle]="overrideListTitle"
        [messageRuleView]="dataView"
        [pageHasContextForm]="hasContextForm"
        (panelContentDisplayed)="onPanelContentDisplayed($event)"
        (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
        (panelContentModified)="onPanelContentModified($event)"
        (panelDataUpdated)="onPanelDataUpdated($event)"
      ></lm-page-panel>
    }

    @if (!hasPanels) {
      <div class="noPageDetails">
        <p>{{noPageDetailsString}}</p>
      </div>
    }
  </div>
</ng-template>

<ng-template #ToolbarMarkup>
  @if (hideTitleBar && bannerInRoute) {
    <lm-toolbar
        [class.hideTitleToolbar]="!isRouterOutletRootComponent"
        [class.header]="pageSpec && pageSpec.pageSpec.hasCartForm"
        [inHeader]="isRouterOutletRootComponent && bannerInRoute"
        [toolbarIdPrefix]="screenId"
        [sectionTitle]="pageTitle"
        [buttons]="toolbarButtons | async"
        [moreMenuSettings]="toolbarMoreMenuSettings"

        (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"
        (toolbarButtonEvent)="onToolbarButtonButtonEvent($event)"
    ></lm-toolbar>
  }
</ng-template>

<ng-template #MultiPanelMarkup>
  @for (tab of lmTabsOptions?.tabs; track trackById($index, tab)) {
    <div soho-tab-panel
        tabId="{{tab.id}}"
        [ngStyle]="{'height': onMobile ? '100%' : null}"
        attr.data-automation-id="lm-{{tab.automationId}}-panel"

    >
      <lm-page-panel #LMPagePanelComponent
          [panel]="tab?.panel"
          [insideTabs]="hideTitleBar"
          [messageRuleView]="dataView"
          [pageHasContextForm] = "hasContextForm"
          [pageHasTabs]="true"
          (panelContentDisplayed)="onPanelContentDisplayed($event)"
          (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
          (sendContextMessageEvent)="onSendContextMessageEvent($event)"
          (panelContentModified)="onPanelContentModified($event)"
          (panelDataUpdated)="onPanelDataUpdated($event)"
      ></lm-page-panel>
    </div>
  }
</ng-template>

<div #dialogPlaceholder id="lmPageDialogPlaceholder" class="lmDialogPlaceholder"></div>